import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { cubicBezier } from '@styles/vars/cubicBezier.style'
import { mq } from '@styles/vars/media-queries.style'
import { transparentize } from 'polished'
import styled from 'styled-components'

const btnWidthMin = 48
const btnWidthMax = 86

export const PlayButtonMain = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  text-align: center;
  cursor: pointer;
  width: 170px;
  height: 54px;
  ${mq.tabletL} {
    width: 211px;
    height: 80px;
  }
`

export const PlayButtonCircle = styled.div`
  transform: scale(${props => (props.show ? 1 : 0)});
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  ${mq.tabletL} {
    width: 86px;
    height: 86px;
  }
  color: ${colors.white};
  background-color: ${transparentize(0.8, colors.charcoal)};
  border-radius: 50%;
  border: 0.1rem solid ${colors.white};
  transition: transform 0.2s ${cubicBezier.inOut}${props => (props.show ? '0.4s' : '')};
  color: ${colors.white}
  > * {
    ${clamp('max-width', 116, 236)}
  }
`


export const PlayButtonInner = styled.div`
  display: flex;
  color: ${colors.white};
  justify-content: center;
  align-items: center;
  pointer-events: none;
  svg {
    width: 13px;
  }
`
export const PlayerLabel = styled.span`
  display: block;
  white-space: nowrap;
  font-weight: bold;
`

export const PlayerTime = styled.span`

`

export const PlayButtonContent = styled.div`
  margin-left: 20px;
  text-align: left;
`
